import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBike: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBike"><Circle cx="5" cy="15" r="4.5" stroke="currentColor"/><Circle cx="19" cy="15" r="4.5" stroke="currentColor"/><Path d="M12 12.5L16.5 8" stroke="currentColor" strokeLinecap="square"/><Path d="M5.5 6.5H8.5M6.5 6.75L12 12.75V15H5" stroke="currentColor" strokeLinecap="square"/><Path d="M19 15L15.5 4.5H13.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBike;
